"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = __importDefault(require("../title/index"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@components/container/exercise");
const Pagination_1 = require("@components/Pagination");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;
    } 
    
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
const ReferenceArea = styled_components_1.default.div `
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 16px;
    padding: 8px;
    padding-top: 50px;
    flex-wrap: wrap;
    border: 1px solid #000;
    width: ${props => props.containerWidth ? `${props.containerWidth}px` : '500px'};
    position: relative;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
`;
const TextForOrder = styled_components_1.default.div `
    position: absolute;
    background: transparent;
    padding: 5px 20px;
    margin-bottom: 40px;
    border-radius: 25px;
    user-select: none;
    //top: 5%;
    //left: 45%;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    top: 5%;
    font-size: clamp(16px, 3vw, 60px);
    font-weight: 700;
    color: #6E76FB;
    line-height: 21px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    @media (max-width: 870px) {
        font-size: 30px;
        padding: 4px 15px;
    }

    @media (max-width: 540px) {
        font-size: 25px;
        padding: 3px 10px;
    }
`;
const GroupContainer = styled_components_1.default.div `
    display: flex;
    margin: 16px;
    padding: 16px;
    flex-wrap: wrap;
    border: 1px solid #000;
    width: 100%;
    height: 150px;
    background-color: #f9f9f9;
    border-radius: 8px;
    min-height: 150px;
    justify-content: start;
    align-items: start;
    box-sizing: border-box;
`;
const WordItem = styled_components_1.default.div `
    margin: 12px;
    background: transparent;
    padding: 5px 20px;
    border: 1px dashed #6E76FB;
    border-radius: 25px;
    cursor: pointer;
    user-select: none;
    font-size: clamp(16px, 3vw, 60px);
    font-weight: 700;
    color: #6E76FB;
    line-height: 21px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    ${props => props.isCorrect !== undefined && `
        border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
        color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
    `}

    &:hover {
        background-color: #dcdcdc;
    }

    @media (max-width: 870px) {
    //font-size: 30px;
    padding: 4px 15px;
}

    @media (max-width: 540px) {
        //font-size: 25px;
        padding: 3px 10px;
    }

    @media (max-height: 850px) {
        line-height: 16px;
    }

    @media (max-height: 744px) {
        line-height: 16px;
    }
`;
const Word = ({ word, index, moveWord, groupIndex, isReference, isCorrect }) => {
    const uniqueKey = `${word.word}-${word.group}-${word.id}`;
    const [, ref] = (0, react_dnd_1.useDrag)(() => ({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        type: "WORD",
        item: { uniqueKey, groupIndex },
    }));
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: "WORD",
        hover: (draggedItem) => {
            if (draggedItem.uniqueKey !== uniqueKey ||
                draggedItem.groupIndex !== groupIndex) {
                moveWord(draggedItem.uniqueKey, uniqueKey, draggedItem.groupIndex, groupIndex);
                draggedItem.groupIndex = groupIndex;
            }
        },
    });
    return (react_1.default.createElement(WordItem, { ref: (node) => ref(drop(node)), group: word.group, isCorrect: word === null || word === void 0 ? void 0 : word.isCorrect, isReference: isReference }, word.word));
};
const Group = ({ group, words, moveWord }) => {
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: "WORD",
        drop: (draggedItem) => {
            const fromGroupIndex = draggedItem.groupIndex;
            const toGroupIndex = group - 1;
            if (fromGroupIndex !== toGroupIndex) {
                moveWord(draggedItem.uniqueKey, "", fromGroupIndex, toGroupIndex);
                draggedItem.groupIndex = toGroupIndex;
            }
        },
    });
    return (react_1.default.createElement(GroupContainer, { ref: drop }, words.map((word, index) => (react_1.default.createElement(Word, { key: `${word.word}-${word.group}-${index}`, word: word, index: index, moveWord: moveWord, isReference: false, groupIndex: group - 1 })))));
};
const Container = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    align-items: self-start;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`;
let widthEl;
const groupWordsByGroup = (words) => {
    return words.reduce((acc, word) => {
        const groupIndex = word.column_id - 1;
        if (!acc[groupIndex])
            acc[groupIndex] = [];
        acc[groupIndex].push(word);
        return acc;
    }, []);
};
const Text_7_2 = ({ response, description, langId }) => {
    const [words, setWords] = (0, react_1.useState)([[], [], []]);
    const [referenceWords, setReferenceWords] = (0, react_1.useState)([]);
    const currentContainerRef = (0, react_1.useRef)(null);
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(uiConfigs_1.initialButtonState);
    const [, setTitle] = (0, react_1.useState)('');
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const windowWidth = (0, useWindowWidrh_1.default)();
    const getLabel = () => {
        if (+langId === 1) {
            return "Проверить";
        }
        return "Check";
    };
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (response) {
            setTitle((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title);
            // const groupedWords = groupAndSortItems( response?.form );
            setReferenceWords(response === null || response === void 0 ? void 0 : response.form);
        }
    }, [response]);
    const moveWord = (fromKey, toKey, fromGroupIndex, toGroupIndex) => {
        const updatedWords = [...words];
        let movedWord;
        if (fromGroupIndex === -1) {
            const fromIndex = referenceWords.findIndex((w) => `${w.word}-${w.group}-${w.id}` === fromKey);
            if (fromIndex !== -1) {
                [movedWord] = referenceWords.splice(fromIndex, 1);
            }
            else {
                console.error(`Ошибка: слово с ключом ${fromKey} не найдено в ReferenceArea`);
                return;
            }
        }
        else if (fromGroupIndex >= 0 && fromGroupIndex < updatedWords.length) {
            const fromIndex = updatedWords[fromGroupIndex].findIndex((w) => `${w.word}-${w.group}-${w.id}` === fromKey);
            if (fromIndex !== -1) {
                [movedWord] = updatedWords[fromGroupIndex].splice(fromIndex, 1);
            }
            else {
                console.error(`Ошибка: слово с ключом ${fromKey} не найдено в группе ${fromGroupIndex}`);
                return;
            }
        }
        else {
            console.error(`Ошибка: некорректный fromGroupIndex ${fromGroupIndex}`);
            return;
        }
        if (!movedWord) {
            console.error(`Ошибка: перемещаемое слово не определено (${fromKey})`);
            return;
        }
        // Добавление в новую группу
        if (toGroupIndex >= 0 && toGroupIndex < updatedWords.length) {
            const group = updatedWords[toGroupIndex];
            if (toKey) {
                const toIndex = group.findIndex((w) => `${w.word}-${w.group}-${w.id}` === toKey);
                if (toIndex !== -1) {
                    group.splice(toIndex, 0, movedWord);
                }
                else {
                    group.push(movedWord);
                }
            }
            else {
                group.push(movedWord);
            }
        }
        else {
            console.warn(`Warning: Invalid toGroupIndex ${toGroupIndex}`);
        }
        setReferenceWords(referenceWords);
        setWords(updatedWords);
    };
    const checkSentence = () => {
        const checkCorrectSubArray = (subArray) => {
            const correctOrder = [...subArray].sort((a, b) => a.order - b.order);
            const groupMap = new Map();
            subArray.forEach((word) => {
                if (!groupMap.has(word.group)) {
                    groupMap.set(word.group, []);
                }
                groupMap.get(word.group).push(word);
            });
            return subArray.map((word, index) => {
                const group = groupMap.get(word.group);
                if (group.length === 1) {
                    return Object.assign(Object.assign({}, word), { isCorrect: correctOrder[index].order === word.order });
                }
                else {
                    const correctGroupOrder = group.sort((a, b) => a.order - b.order);
                    const correctIndex = correctGroupOrder.findIndex(g => g.order === word.order);
                    if (correctIndex === index) {
                        return Object.assign(Object.assign({}, word), { isCorrect: true });
                    }
                    else {
                        return Object.assign(Object.assign({}, word), { isCorrect: false });
                    }
                }
            });
        };
        const updatedSentence = words.map(subArray => {
            return checkCorrectSubArray(subArray);
        });
        setWords(updatedSentence);
        const isAllCorrect = updatedSentence.every(subArray => subArray.every(word => word.isCorrect));
        if (isAllCorrect) {
            handleAddCoin();
            audioPlayer_1.audioPlayer.playAudio(+langId === 1 ? audioPathNames_1.AudioPathNames.Correct : audioPathNames_1.AudioPathNames.Correct_en);
            // @ts-ignore
            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
        }
        return isAllCorrect;
    };
    const handleCheckButtonClick = () => {
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1)
                return prevButtons;
            return prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        // @ts-ignore
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: checkSentence() });
                }
                return button;
            });
        });
    };
    (0, react_1.useLayoutEffect)(() => {
        const updateContainerWidth = () => {
            if (currentContainerRef.current) {
                widthEl = currentContainerRef.current.clientWidth;
            }
        };
        updateContainerWidth();
        window.addEventListener('resize', updateContainerWidth);
        return () => {
            window.removeEventListener('resize', updateContainerWidth);
        };
    }, []);
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        windowWidth <= 1200 ? react_1.default.createElement(smallHeader_1.default, { exerciseName: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0440\u0430\u0437 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439" }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            windowWidth <= 1200 ? react_1.default.createElement(react_1.default.Fragment, null) :
                react_1.default.createElement(index_1.default, { text: "\u0421\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0444\u0440\u0430\u0437 \u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439" }),
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(Container, { ref: currentContainerRef }, words.map((groupWords, groupIndex) => (react_1.default.createElement(Group, { key: `group-${groupIndex}`, group: groupIndex + 1, words: groupWords, moveWord: moveWord })))),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(ReferenceArea, null,
                    react_1.default.createElement(TextForOrder, null, "\u0421\u043B\u043E\u0432\u0430 \u0434\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u043E\u043A:"),
                    groupWordsByGroup(referenceWords).map((group, groupIndex) => (react_1.default.createElement("div", { key: `reference-group-${groupIndex}` }, group.map((word, index) => (react_1.default.createElement(Word, { key: `${word.word}-${index}`, word: word, index: index, moveWord: moveWord, groupIndex: -1, isReference: true }))))))),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(button_1.default, { isShowShadow: false, label: getLabel(), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = Text_7_2;
